var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9801 56.089C21.7903 56.089 11.8711 46.1699 11.8711 33.9801C11.8711 21.7903 21.7903 11.8711 33.9801 11.8711C46.1699 11.8711 56.089 21.7903 56.089 33.9801C56.089 46.1699 46.1699 56.089 33.9801 56.089Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9801 8.5249C33.4224 8.5249 32.9443 8.0867 32.9443 7.48916V1.03574C32.9443 0.478032 33.4224 0 33.9801 0C34.5776 0 35.0158 0.478032 35.0158 1.03574V7.48916C35.0158 8.0867 34.5776 8.5249 33.9801 8.5249Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2455 12.0703C47.0463 12.0703 46.887 12.0305 46.7276 11.9508C46.2097 11.6719 46.0504 11.0346 46.3293 10.5565L49.5958 4.93965C49.8747 4.42178 50.512 4.26244 50.9901 4.54129C51.4681 4.82014 51.6673 5.45752 51.3486 5.97539L48.1219 11.5524C47.9227 11.9109 47.604 12.0703 47.2455 12.0703Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9256 21.7903C56.5671 21.7903 56.2085 21.5911 56.0492 21.2724C55.7703 20.7545 55.9297 20.157 56.4077 19.8383L62.0246 16.6116C62.5026 16.3328 63.14 16.4921 63.4189 17.01C63.6977 17.488 63.5384 18.1254 63.0603 18.4042L57.4435 21.6309C57.2841 21.7504 57.1248 21.7903 56.9256 21.7903Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9642 35.0158H60.471C59.9133 35.0158 59.4352 34.5776 59.4352 33.9801C59.4352 33.4224 59.9133 32.9443 60.471 32.9443H66.9642C67.5219 32.9443 68 33.4224 68 33.9801C68 34.5776 67.5219 35.0158 66.9642 35.0158Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5425 51.5079C62.3433 51.5079 62.1839 51.4681 62.0246 51.3486L56.4077 48.1219C55.9297 47.843 55.7703 47.2056 56.0492 46.7276C56.3281 46.2097 56.9654 46.0504 57.4435 46.3293L63.0603 49.5958C63.5384 49.8747 63.6977 50.512 63.4189 50.9901C63.2595 51.3088 62.901 51.5079 62.5425 51.5079Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4722 63.5782C50.1137 63.5782 49.7551 63.379 49.5958 63.0603L46.3293 57.4435C46.0504 56.9654 46.2097 56.3281 46.7276 56.0492C47.2056 55.7703 47.843 55.9297 48.1219 56.4077L51.3486 62.0246C51.6673 62.5026 51.4681 63.14 50.9901 63.4189C50.8307 63.5384 50.6315 63.5782 50.4722 63.5782Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9801 68C33.4224 68 32.9443 67.5219 32.9443 66.9642V60.471C32.9443 59.9133 33.4224 59.4352 33.9801 59.4352C34.5776 59.4352 35.0158 59.9133 35.0158 60.471V66.9642C35.0158 67.5219 34.5776 68 33.9801 68Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5278 63.5782C17.3287 63.5782 17.1693 63.5384 17.01 63.4189C16.4921 63.14 16.3328 62.5026 16.6116 62.0246L19.8383 56.4077C20.157 55.9297 20.7545 55.7305 21.2724 56.0492C21.7504 56.3281 21.9098 56.9654 21.6309 57.4435L18.4042 63.0603C18.205 63.379 17.8864 63.5782 17.5278 63.5782Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45752 51.5079C5.09899 51.5079 4.74047 51.3088 4.54129 50.9901C4.26244 50.512 4.42178 49.8747 4.93965 49.5958L10.5565 46.3293C11.0346 46.0504 11.6719 46.2097 11.9508 46.7276C12.2296 47.2056 12.0703 47.843 11.5923 48.1219L5.97539 51.3486C5.81604 51.4681 5.61686 51.5079 5.45752 51.5079Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48916 35.0158H1.03574C0.478032 35.0158 0 34.5776 0 33.9801C0 33.4224 0.478032 32.9443 1.03574 32.9443H7.48916C8.0867 32.9443 8.5249 33.4224 8.5249 33.9801C8.5249 34.5776 8.0867 35.0158 7.48916 35.0158Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0744 21.7903C10.8752 21.7903 10.7159 21.7504 10.5565 21.6309L4.93965 18.4042C4.42178 18.1254 4.26244 17.488 4.54129 17.01C4.82014 16.4921 5.45752 16.3328 5.97539 16.6116L11.5923 19.8383C12.0703 20.157 12.2296 20.7545 11.9508 21.2724C11.7516 21.5911 11.3931 21.7903 11.0744 21.7903Z",
    fill: "#056E9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7545 12.0703C20.396 12.0703 20.0375 11.9109 19.8383 11.5923L16.6116 5.97539C16.3328 5.45752 16.4921 4.82014 17.01 4.54129C17.488 4.26244 18.1254 4.42178 18.4042 4.93965L21.6309 10.5565C21.9098 11.0346 21.7504 11.6719 21.2724 11.9508C21.1131 12.0305 20.9139 12.0703 20.7545 12.0703Z",
    fill: "#056E9C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4692 46.5284C41.3497 46.5284 41.2302 46.5284 41.1107 46.4487L33.9801 43.7L26.8893 46.4487C26.5706 46.6081 26.1722 46.5284 25.8934 46.3292C25.6145 46.13 25.4552 45.8113 25.495 45.4528L25.9332 37.8441L21.0732 31.9484C20.874 31.6696 20.7944 31.311 20.9139 30.9525C21.0334 30.6338 21.2724 30.355 21.6309 30.2753L29.0006 28.3632L33.1435 21.9098C33.3029 21.6309 33.6614 21.4716 33.9801 21.4716C34.3386 21.4716 34.6573 21.6309 34.8565 21.9098L38.9994 28.3632L46.3691 30.2753C46.6878 30.355 46.9666 30.6338 47.0861 30.9525C47.2056 31.311 47.1259 31.6696 46.8869 31.9484L42.0668 37.8441L42.505 45.4528C42.505 45.8113 42.3456 46.13 42.0668 46.3292C41.9074 46.4885 41.6684 46.5284 41.4692 46.5284Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.f01f8ec0c986581f138c83f835905aad.svg";
export { ForwardRef as ReactComponent };